<div
  id="sidebar"
  *ngIf="isLogin"
  [ngClass]="{ 'collapse-sidebar': isSidebarCollapsed }"
>
  <app-sidebar (getToggleValue)="onSidebarToggle($event)"></app-sidebar>
</div>

<div class="content" [ngClass]="{ 'expand-main-content': isSidebarCollapsed }">
  <router-outlet></router-outlet>
</div>
